export const environment = {
  production: false,
  backend: 'https://s3cms.testcloud.investments.momentum.co.za/s3cms'
};
